import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { motion } from "framer-motion";
import { revealItem } from "@/components/Reveal";

export default function ArticleCard({ guide, featured = false }) {
  return (
    <motion.article variants={revealItem} className="h-full">
      <Link
        to={`/guides/${guide.slug}`}
        className="group flex flex-col h-full overflow-hidden rounded-3xl bg-card border border-forest/10 hover:border-forest/20 transition-all hover:shadow-xl hover:shadow-forest/5 hover:-translate-y-1 duration-300"
        data-testid={`article-card-${guide.slug}`}
      >
        <div className={`relative overflow-hidden ${featured ? "h-64" : "h-48"}`}>
          <img
            src={guide.image}
            alt={guide.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-cream/95 text-[11px] font-mono uppercase tracking-wider text-forest font-medium">
            {guide.category}
          </span>
        </div>
        <div className="flex flex-col flex-1 p-6">
          <h3 className={`font-serif font-bold text-forest-950 group-hover:text-terracotta transition-colors ${featured ? "text-2xl" : "text-lg"}`}>
            {guide.title}
          </h3>
          <p className="mt-2 text-sm text-forest-950/70 leading-relaxed flex-1">{guide.excerpt}</p>
          <div className="mt-5 flex items-center justify-between text-xs text-forest-950/50">
            <span>{guide.author}</span>
            <span className="flex items-center gap-1.5">
              <Clock className="w-3.5 h-3.5" />
              {guide.readingTime} min read
            </span>
          </div>
        </div>
      </Link>
    </motion.article>
  );
}
